<template>
  <img
    class="rating-icon"
    :class="{mlb2: mlb2}"
    :src="item.logo" v-if="item" :title="item.label" />
</template>

<script>
import Constants from '@/constants'

export default {
  props: {
    value: String,
    mlb2: Boolean
  },
  computed: {
    item () {
      if (!this.value) return
      return Constants.ratings.filter(r => r.value === this.value)[0]
    }
  }
}
</script>
<style scoped>
  .rating-icon {
    height: 20px;
    vertical-align: middle;
    padding-right: 8px;
  }
  .mlb2 {
    margin-left: 8px;
    margin-bottom: 8px;
  }
</style>
<style>
  .image-viewer--rating {
    position: absolute;
  }
</style>